import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatIconModule} from '@angular/material/icon';

import {LearningRingsComponent} from './learning-rings.component';

@NgModule({
  declarations: [LearningRingsComponent],
  exports:      [LearningRingsComponent],
  imports:      [CommonModule, MatIconModule, FlexLayoutModule]
})
export class LearningRingsModule {}
